import React, { useEffect, useState } from 'react';
import { Location } from '../types';

export const LocationContext = React.createContext<Location | undefined>(
    undefined
);

export const getUserLocation = async (): Promise<Location> => {
    return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(
            (position) => {
                const latitude = position.coords.latitude;
                const longitude = position.coords.longitude;
                const location = {
                    lat: latitude,
                    long: longitude,
                };
                resolve(location);
            },
            (error) => {
                // user declined to share location
                console.error(error);
                reject(error);
            }
        );
    });
};

export const LocationProvider: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {
    const [sharedChoice, setSharedChoice] = useState<boolean>(false);
    const [location, setLocation] = useState<Location>();

    useEffect(() => {
        getUserLocation()
            .then((result) => setLocation(result))
      .catch(() => {}) // eslint-disable-line
            .finally(() => setSharedChoice(true)); // whether they accept or not, they made a choice
    }, []);

    return (
        <LocationContext.Provider value={location}>
            {!sharedChoice ? <div>Waiting for location...</div> : children}
        </LocationContext.Provider>
    );
};
